import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SearchService = /** @class */ (function () {
    function SearchService(http) {
        this.http = http;
    }
    SearchService.prototype.getFund = function (search) {
        var URL = cmsApi + '/get_fundBySearch';
        var body = { search: search };
        return this.http.post(URL, body);
    };
    SearchService.prototype.getNews = function (search) {
        var URL = cmsApi + '/get_newsListBySearch';
        var body = { IsActive: 1, search: search };
        return this.http.post(URL, body);
    };
    SearchService.prototype.getAnnounce = function (search) {
        var URL = cmsApi + '/get_announceListByKeyword';
        var body = { IsActive: 1, search: search };
        return this.http.post(URL, body);
    };
    SearchService.prototype.getEarthUpdate = function (search) {
        var URL = cmsApi + '/get_earthupdateListByKeyword';
        var body = { IsActive: 1, search: search };
        return this.http.post(URL, body);
    };
    SearchService.prototype.getFundRecom = function (search) {
        var URL = cmsApi + '/get_fundRecomList_active_2';
        var body = { IsActive: 1, search: search };
        return this.http.post(URL, body);
    };
    SearchService.prototype.getPromotion = function (search) {
        var URL = cmsApi + '/get_promotionListByKeyword';
        var body = { IsActive: 1, search: search };
        return this.http.post(URL, body);
    };
    SearchService.prototype.getBenefit = function (search) {
        var URL = cmsApi + '/get_benefitList_active_2';
        var body = { IsActive: 1, search: search };
        // console.log(search)
        return this.http.post(URL, body);
    };
    SearchService.ngInjectableDef = i0.defineInjectable({ factory: function SearchService_Factory() { return new SearchService(i0.inject(i1.HttpClient)); }, token: SearchService, providedIn: "root" });
    return SearchService;
}());
export { SearchService };
